<template>
<div class="flex-center">
  <el-row class="dashboard">
    <el-col :xs="24" :md="12">
      <nxs-admin-files />
    </el-col>
    <el-col :xs="24" :md="12">
      <nxs-admin-announcements />
    </el-col>
  </el-row>
  </div>
</template>

<style scoped>
.dashboard {
  max-width: 56em;
  width: 100%;
}
.flex-center {
  padding: 1.2em;
  display:flex;
  justify-content: center;
}
</style>
<script>
import nxsAdminAnnouncements from './Announcements.vue';
import nxsAdminFiles from './Files.vue';

export default {components: {nxsAdminAnnouncements, nxsAdminFiles}}
</script>
